import { brl } from "@/lib/api";
import { openPrintWindow, safeImageUrl } from "@/lib/printWindow";

const CSS = `
  body{font-family:system-ui;padding:24px;max-width:600px;margin:auto}
  header{display:flex;align-items:center;gap:16px;border-bottom:2px solid #0F172A;padding-bottom:12px;margin-bottom:16px}
  header img{max-height:60px;max-width:120px;object-fit:contain}
  header h1{margin:0;letter-spacing:-0.02em}
  header .info{font-size:11px;color:#555;margin-top:4px}
  h2{margin:16px 0 4px;letter-spacing:-0.02em}
  table{width:100%;border-collapse:collapse;margin-top:16px}
  th,td{text-align:left;padding:6px;border-bottom:1px solid #ddd}
  .right{text-align:right}.total{font-size:1.3em;font-weight:700}
`;

const companyHeader = (el, co) => {
  const logo = safeImageUrl(co.logo_url);
  const contact = [co.phone, co.email].filter(Boolean).join(" • ");
  return el("header", {}, [
    logo && el("img", { src: logo, alt: "logo" }),
    el("div", {}, [
      el("h1", {}, co.name || "NEXUS PDV"),
      el("div", { class: "info" }, [
        co.cnpj && el("div", {}, `CNPJ: ${co.cnpj}`),
        co.address && el("div", {}, co.address),
        contact && el("div", {}, contact),
      ]),
    ]),
  ]);
};

const itemsTable = (el, items) => el("table", {}, [
  el("thead", {}, el("tr", {}, [
    el("th", {}, "Item"), el("th", { class: "right" }, "Qtd"),
    el("th", { class: "right" }, "Unit."), el("th", { class: "right" }, "Total"),
  ])),
  el("tbody", {}, items.map((it) => el("tr", {}, [
    el("td", {}, it.name), el("td", { class: "right" }, String(it.quantity)),
    el("td", { class: "right" }, brl(it.price)), el("td", { class: "right" }, brl(it.price * it.quantity)),
  ]))),
]);

const line = (el, label, value) => el("div", {}, [el("b", {}, `${label} `), value]);

export const printQuote = (q, co = {}) => openPrintWindow({
  title: "Orçamento",
  css: CSS,
  build: (body, el) => {
    body.append(
      companyHeader(el, co),
      el("h2", {}, `Orçamento #${q.id.slice(-6).toUpperCase()}`),
      el("div", {}, [
        line(el, "Cliente:", q.customer || "—"),
        line(el, "Validade:", `${q.valid_until} (${q.validity_days} dias)`),
        line(el, "Emitido em:", new Date(q.created_at).toLocaleString("pt-BR")),
      ]),
      itemsTable(el, q.items),
      el("p", { class: "right" }, [
        el("div", {}, `Subtotal: ${brl(q.subtotal)}`),
        el("div", {}, `Desconto: -${brl(q.discount)}`),
        el("div", { class: "total" }, `Total: ${brl(q.total)}`),
      ]),
      q.notes ? el("p", {}, [el("b", {}, "Observações: "), q.notes]) : "",
    );
  },
});
